/**
 * ft-video-controls.js — Minimal custom Vimeo/YouTube overlay controls.
 * Play/pause + progress + volume + fullscreen. Auto-hides native player UI.
 *
 * Usage:
 *   window.initFtVideoControls(iframeEl, containerEl, { onOpen, onClose });
 *
 * The container element must contain these children (usually rendered by the
 * `ft-video-controls-overlay` snippet):
 *   [data-ftv-catcher]         → click-catcher div
 *   [data-ftv-play-pause-btn]  → play/pause button
 *   [data-ftv-progress]        → progress bar (with .fill/.buffer/.handle children)
 *   [data-ftv-mute]            → mute button
 *   [data-ftv-vol-slider]      → volume slider (with .fill child)
 *   [data-ftv-fs]              → fullscreen button
 */
(function () {
  if (window.initFtVideoControls) return;

  window.initFtVideoControls = function (iframe, container, opts) {
    opts = opts || {};
    if (!iframe || !container) return null;

    var baseSrc = iframe.getAttribute('src') || '';
    var isVimeo = baseSrc.includes('player.vimeo.com');
    var isYT    = baseSrc.includes('youtube.com/embed') || baseSrc.includes('youtube-nocookie.com/embed');

    var $ = function (sel) { return container.querySelector(sel); };
    var catcher   = $('[data-ftv-catcher]');
    var ppBtn     = $('[data-ftv-play-pause-btn]');
    var iconPlay  = $('.ftv-icon-play');
    var iconPause = $('.ftv-icon-pause');
    var progress  = $('[data-ftv-progress]');
    var fill      = $('.ftv-progress__fill');
    var buffer    = $('.ftv-progress__buffer');
    var handle    = $('.ftv-progress__handle');
    var muteBtn   = $('[data-ftv-mute]');
    var iconVolHi = $('.ftv-icon-vol-hi');
    var iconVolMt = $('.ftv-icon-vol-mute');
    var volSlider = $('[data-ftv-vol-slider]');
    var volFill   = $('.ftv-vol__fill');
    var fsBtn     = $('[data-ftv-fs]');
    var controls  = $('.ftv-controls');
    var timeCur   = $('[data-ftv-time-current]');
    var timeTot   = $('[data-ftv-time-total]');
    var fsTarget  = opts.fsTarget || container;

    function fmtTime(s) {
      s = Math.max(0, Math.floor(s || 0));
      var h = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      var pad = function (n) { return n < 10 ? '0' + n : n; };
      return h > 0 ? h + ':' + pad(m) + ':' + pad(sec) : m + ':' + pad(sec);
    }
    function setTimes(current, total) {
      if (timeCur && current != null) timeCur.textContent = fmtTime(current);
      if (timeTot && total   != null) timeTot.textContent = fmtTime(total);
    }

    var duration = 0;
    var isPlaying = false;
    var isMuted = false;
    var currentVolume = 1;
    var lastVolume = 1;
    var iframeReady = false;
    var hideTimer = null;

    iframe.addEventListener('load', function () { iframeReady = true; });

    function vSend(method, value) {
      try {
        var msg = value !== undefined ? { method: method, value: value } : { method: method };
        iframe.contentWindow.postMessage(JSON.stringify(msg), '*');
      } catch (e) {}
    }
    function ytSend(func, args) {
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: args || [] }), '*');
      } catch (e) {}
    }

    function updatePlayIcon() {
      if (iconPlay)  iconPlay.style.display  = isPlaying ? 'none'  : 'block';
      if (iconPause) iconPause.style.display = isPlaying ? 'block' : 'none';
    }
    function updateVolumeIcon() {
      var muted = isMuted || currentVolume === 0;
      if (iconVolHi) iconVolHi.style.display = muted ? 'none'  : 'block';
      if (iconVolMt) iconVolMt.style.display = muted ? 'block' : 'none';
      if (volFill)   volFill.style.width = (muted ? 0 : currentVolume * 100) + '%';
    }
    function updateProgress(current, dur, pct) {
      if (!dur) return;
      var p = pct != null ? pct : (current / dur);
      var w = Math.max(0, Math.min(1, p)) * 100;
      if (fill)   fill.style.width = w + '%';
      if (handle) handle.style.left = w + '%';
    }
    function showControls(persistent) {
      if (!controls) return;
      controls.classList.add('is-visible');
      clearTimeout(hideTimer);
      if (!persistent && isPlaying) {
        hideTimer = setTimeout(function () { controls.classList.remove('is-visible'); }, 2500);
      }
    }
    updatePlayIcon();
    updateVolumeIcon();

    // Bind player events
    window.addEventListener('message', function (e) {
      if (!e || !e.data) return;
      var data = e.data;
      if (typeof data === 'string') { try { data = JSON.parse(data); } catch (_) { return; } }
      if (!data) return;
      // Only react to messages from OUR iframe
      if (e.source !== iframe.contentWindow) return;

      if (isVimeo) {
        if (data.event === 'ready') {
          vSend('addEventListener', 'timeupdate');
          vSend('addEventListener', 'progress');
          vSend('addEventListener', 'play');
          vSend('addEventListener', 'pause');
          vSend('addEventListener', 'ended');
          vSend('addEventListener', 'volumechange');
          vSend('getDuration');
          vSend('getVolume');
        }
        if (data.event === 'timeupdate' && data.data) {
          if (data.data.duration) duration = data.data.duration;
          updateProgress(data.data.seconds, data.data.duration || duration, data.data.percent);
          setTimes(data.data.seconds, data.data.duration || duration);
        }
        if (data.event === 'progress' && data.data && data.data.percent != null) {
          if (buffer) buffer.style.width = (data.data.percent * 100) + '%';
        }
        if (data.event === 'play')  { isPlaying = true;  updatePlayIcon(); }
        if (data.event === 'pause') { isPlaying = false; updatePlayIcon(); showControls(true); }
        if (data.event === 'ended') { isPlaying = false; updatePlayIcon(); showControls(true); }
        if (data.event === 'volumechange' && data.data && typeof data.data.volume === 'number') {
          currentVolume = data.data.volume;
          isMuted = currentVolume === 0;
          updateVolumeIcon();
        }
        if (data.method === 'getDuration' && typeof data.value === 'number') { duration = data.value; setTimes(null, duration); }
      } else if (isYT) {
        if (data.event === 'infoDelivery' && data.info) {
          if (data.info.duration) { duration = data.info.duration; setTimes(null, duration); }
          if (data.info.currentTime != null) { updateProgress(data.info.currentTime, duration); setTimes(data.info.currentTime, duration); }
          if (data.info.volume != null) {
            currentVolume = data.info.volume / 100;
            isMuted = !!data.info.muted;
            updateVolumeIcon();
          }
        }
        if (data.event === 'onStateChange') {
          if (data.info === 1) { isPlaying = true;  updatePlayIcon(); }
          if (data.info === 2 || data.info === 0) { isPlaying = false; updatePlayIcon(); showControls(true); }
        }
      }
    });

    // Play/pause
    function togglePlayPause() {
      if (isPlaying) {
        if (isVimeo) vSend('pause'); else if (isYT) ytSend('pauseVideo');
      } else {
        if (isVimeo) vSend('play');  else if (isYT) ytSend('playVideo');
      }
      showControls(true);
    }
    if (catcher) catcher.addEventListener('click', function (e) { e.stopPropagation(); togglePlayPause(); });
    if (ppBtn)   ppBtn.addEventListener('click',   function (e) { e.stopPropagation(); togglePlayPause(); });

    // Progress seek — instant visual feedback, throttled backend calls
    if (progress) {
      var seekDragging = false;
      var pendingPct = null;
      var lastSentAt = 0;
      var seekRAF = null;

      function updateBarUI(pct) {
        var w = pct * 100;
        if (fill)   fill.style.width = w + '%';
        if (handle) handle.style.left = w + '%';
      }
      function sendSeek(pct) {
        if (isVimeo) {
          if (duration) vSend('setCurrentTime', pct * duration);
          else vSend('seekTo', pct);
        } else if (isYT && duration) {
          ytSend('seekTo', [pct * duration, true]);
        }
      }
      function pctFromClient(clientX) {
        var rect = progress.getBoundingClientRect();
        return Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      }
      function scheduleUI() {
        if (seekRAF) return;
        seekRAF = requestAnimationFrame(function () {
          seekRAF = null;
          if (pendingPct != null) updateBarUI(pendingPct);
          // Throttle backend seek to max 8fps during drag (avoids Vimeo overload → lag)
          var now = performance.now();
          if (pendingPct != null && now - lastSentAt > 125) {
            sendSeek(pendingPct);
            lastSentAt = now;
          }
        });
      }
      progress.addEventListener('pointerdown', function (e) {
        seekDragging = true; try { progress.setPointerCapture(e.pointerId); } catch (_){}
        progress.classList.add('is-dragging');
        // Pause during drag → scrub feels crisper (no video playback jitter)
        if (isPlaying) { if (isVimeo) vSend('pause'); else if (isYT) ytSend('pauseVideo'); }
        pendingPct = pctFromClient(e.clientX);
        updateBarUI(pendingPct);
        sendSeek(pendingPct); lastSentAt = performance.now();
        showControls(true);
      });
      progress.addEventListener('pointermove', function (e) {
        if (!seekDragging) return;
        pendingPct = pctFromClient(e.clientX);
        scheduleUI();
      });
      progress.addEventListener('pointerup', function (e) {
        if (!seekDragging) return;
        seekDragging = false;
        progress.classList.remove('is-dragging');
        try { progress.releasePointerCapture(e.pointerId); } catch (_){}
        pendingPct = pctFromClient(e.clientX);
        updateBarUI(pendingPct);
        sendSeek(pendingPct);
        // Resume playback after seek
        setTimeout(function () { if (isVimeo) vSend('play'); else if (isYT) ytSend('playVideo'); }, 60);
      });
      progress.addEventListener('pointercancel', function () {
        seekDragging = false;
        progress.classList.remove('is-dragging');
      });
    }

    // Mute
    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (isMuted || currentVolume === 0) {
          var target = lastVolume > 0 ? lastVolume : 1;
          if (isVimeo) vSend('setVolume', target);
          else if (isYT) { ytSend('unMute'); ytSend('setVolume', [Math.round(target * 100)]); }
          currentVolume = target; isMuted = false;
        } else {
          lastVolume = currentVolume;
          if (isVimeo) vSend('setVolume', 0);
          else if (isYT) ytSend('mute');
          currentVolume = 0; isMuted = true;
        }
        updateVolumeIcon();
        showControls(true);
      });
    }

    // Volume slider
    if (volSlider) {
      var volDragging = false;
      function setVolFromX(clientX) {
        var rect = volSlider.getBoundingClientRect();
        var pct = Math.max(0, Math.min(1, (clientX - rect.left - 4) / (rect.width - 8)));
        currentVolume = pct; isMuted = pct === 0;
        if (isVimeo) vSend('setVolume', pct);
        else if (isYT) {
          if (pct > 0) ytSend('unMute');
          ytSend('setVolume', [Math.round(pct * 100)]);
        }
        if (pct > 0) lastVolume = pct;
        updateVolumeIcon();
      }
      volSlider.addEventListener('pointerdown', function (e) {
        volDragging = true; try { volSlider.setPointerCapture(e.pointerId); } catch (_){}
        setVolFromX(e.clientX); showControls(true);
      });
      volSlider.addEventListener('pointermove', function (e) { if (volDragging) setVolFromX(e.clientX); });
      volSlider.addEventListener('pointerup',   function (e) { volDragging = false; try { volSlider.releasePointerCapture(e.pointerId); } catch (_){} });
    }

    // Fullscreen
    function isFsActive() {
      return !!(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || container.classList.contains('ftv-fs-fallback'));
    }
    function enterFs() {
      var targets = [fsTarget, iframe];
      for (var i = 0; i < targets.length; i++) {
        var t = targets[i];
        if (t.requestFullscreen)         { t.requestFullscreen().catch(function () {}); return; }
        if (t.webkitRequestFullscreen)   { t.webkitRequestFullscreen(); return; }
        if (t.msRequestFullscreen)       { t.msRequestFullscreen(); return; }
      }
      container.classList.add('ftv-fs-fallback');
      try { if (screen.orientation && screen.orientation.lock) screen.orientation.lock('landscape').catch(function () {}); } catch (_){}
    }
    function exitFs() {
      if (document.exitFullscreen)      document.exitFullscreen().catch(function () {});
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      else if (document.msExitFullscreen)     document.msExitFullscreen();
      container.classList.remove('ftv-fs-fallback');
      try { if (screen.orientation && screen.orientation.unlock) screen.orientation.unlock(); } catch (_){}
    }
    if (fsBtn) fsBtn.addEventListener('click', function (e) { e.stopPropagation(); if (isFsActive()) exitFs(); else enterFs(); });
    ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        if (!document.fullscreenElement && !document.webkitFullscreenElement) container.classList.remove('ftv-fs-fallback');
      });
    });

    // Show controls on any pointer move / touch
    container.addEventListener('pointermove', function () { showControls(false); });
    container.addEventListener('touchstart',  function () { showControls(false); }, { passive: true });

    // Public API
    return {
      play:  function () { if (isVimeo) vSend('play');  else if (isYT) ytSend('playVideo'); },
      pause: function () { if (isVimeo) vSend('pause'); else if (isYT) ytSend('pauseVideo'); },
      enterFs: enterFs, exitFs: exitFs, isFsActive: isFsActive
    };
  };
})();
